import React, { useState, useEffect } from 'react';
import RoomListMobile from './roomListMobile';
import RoomListWeb from './roomListWeb';

const useWindowWidth = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowWidth;
};

const RoomListRouter = () => {
  const width = useWindowWidth();
  const MOBILE_BREAKPOINT = 768;

  return width < MOBILE_BREAKPOINT ? <RoomListMobile /> : <RoomListWeb />;
};

export default RoomListRouter;
